module.exports = __webpack_public_path__ + "static/media/revert-icon.09e7e5a0.svg";